import moment from "moment";

const _ = window._;

export const initSearchFormData = (searchFormOrg: searchFormOrg[]) => {
	return _.zipObject(
		searchFormOrg.map(i => i.meta.prop),
		searchFormOrg.map(i => "")
	);
};

export const initSearchFormRules = (searchFormOrg: searchFormOrg[]) => {
	return _.zipObject(
		searchFormOrg.map(i => i.meta.prop),
		searchFormOrg.map(i => i.meta.validator || [])
	);
};

export const clearNoValueObj = obj => {
	let copy = new Object();

	Object.keys({ ...obj }).forEach(k => obj[k] && (copy[k] = obj[k]));

	return copy;
};

export const isEmptyObj = obj => {
	const copy = clearNoValueObj(obj);
	return !Object.keys(copy).length;
};

export const formatDate = (time: number, fmtstring: string = "YYYY-MM-DD HH:mm:ss") => {
	return moment(time).format(fmtstring);
};

export default {
	initSearchFormData,
	initSearchFormRules,
	clearNoValueObj,
	isEmptyObj,
	formatDate
};
